<template>
    <div class="tile-content tile-content-secondary">
        <div class="stack-m">
            <span class="inline-s">Create payment using</span>
            <v-popper-select
                label="Create payment using"
                :options="amountPolicies"
                :validate="$v.action.amountPolicy"
                :value="action.amountPolicy"
                @input="value => update('amountPolicy', value)"/>


        </div>
        <div class="stack-m">
            <span class="inline-s">Schedule payment</span>
            <define-schedule-view
                :fluid="true"
                :schedule-instruction="action.scheduleInstruction"
                :validate="$v.action.scheduleInstruction"
                v-on:update="data => updateSchedule(data)"/>
        </div>
        <div class="display-flex">
            <span class="inline-s">If you have set `Due Time Shift`, <b>Schedule payment</b> will override it.</span>
        </div>
    </div>
</template>

<script>
    import _ from '@/common/helpers';
    import {required} from 'vuelidate/lib/validators';
    import SchedulePaymentActionModel from '@/common/models/rules/actions/schedule-payment-action-model';
    import ScheduleInstructionModel from '@/common/models/rules/schedule-instruction-model';
    import BaseAction from '@/modules/rules-engine/actions/base-action';
    import DefineScheduleView from '@/modules/rules-engine/components/actions/schedule-payment/define-schedule-view';
    import getScheduleValidation
        from '@/modules/rules-engine/components/actions/schedule-payment/get-schedule-validation';
    import {vPopperSelect} from '@/components/form';

    export default {
        name: 'schedule-payment',
        extends: BaseAction,
        components: {
            vPopperSelect,
            DefineScheduleView,
        },
        validations() {
            return {
                action: {
                    amountPolicy: {
                        required,
                    },
                    scheduleInstruction: getScheduleValidation(this.action.scheduleInstruction),
                },
            };
        },
        data() {
            return {
                amountPolicies: Object.values(
                    SchedulePaymentActionModel.AmountPolicies,
                ).map(value => ({
                    value,
                    label: _.unKebabCase(value),
                })),
            };
        },
        methods: {
            getValidationAggregate() {
                return {
                    name: 'schedule-payment',
                    rules: [
                        {
                            name: `The Schedule Payment fields are invalid.`,
                            delegate: () => {
                                this.$v.$touch();
                                return this.$v.$error;
                            },
                        },
                    ],
                };
            },
            update(key, value) {
                Reflect.set(this.action, key, value);
            },
            updateSchedule(data) {
                this.action.scheduleInstruction = new ScheduleInstructionModel({
                    ...this.action.scheduleInstruction,
                    ...data,
                });
            },
        },
    };
</script>
